import React, { useState, useEffect } from "react";
import "./Orders.css";
import { toast } from "react-toastify";
import { FaCheck, FaTimes } from "react-icons/fa";

const Clients = () => {
    const getNewClients = (e) => {
        e.preventDefault();
    };

    const clients = [
        {
            id: 1,
            clientName: "John Smith",
            companyName: "ABC Technologies",
            contact: "+91 9876543210",
            email: "john.smith@abctech.com",
            GSTName: "ABS",
            GSTNumber: "A89S300"
        },
        {
            id: 2,
            clientName: "Emily Johnson",
            companyName: "Global Solutions",
            contact: "+91 9876501234",
            email: "emily@globalsolutions.com",
            GSTName: "ABS",
            GSTNumber: "A89S300"
        },
        {
            id: 3,
            clientName: "Michael Brown",
            companyName: "TechNova Pvt Ltd",
            contact: "+91 9988776655",
            email: "michael@technova.com",
            GSTName: "ABS",
            GSTNumber: "A89S300"
        },
        {
            id: 4,
            clientName: "Sophia Davis",
            companyName: "Skyline Builders",
            contact: "+91 9123456789",
            email: "sophia@skyline.com",
            GSTName: "ABS",
            GSTNumber: "A89S300"
        },
        {
            id: 5,
            clientName: "David Wilson",
            companyName: "Future Systems",
            contact: "+91 9090909090",
            email: "david@futuresystems.com",
            GSTName: "ABS",
            GSTNumber: "A89S300"
        },
    ];

    const handleAccept = (id) => {
        toast.success("Client accepted successfully");
    };

    const handleReject = (id) => {
        toast.error("Client rejected");
    };

    return (
        <div>
            <h1 className="dashboard-heading">Clients</h1>

            <div
                className="report-container"
            >
                <table className="report-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Client Name</th>
                            <th>Company Name</th>
                            <th>Contact</th>
                            <th>Email</th>
                            <th>GST Name</th>
                            <th>GST Number</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients.length > 0 ? (
                            clients.map((client, index) => (
                                <tr key={client.id}>
                                    <td>{index + 1}</td>
                                    <td>{client.clientName}</td>
                                    <td>{client.companyName}</td>
                                    <td>{client.contact}</td>
                                    <td>{client.email}</td>
                                    <td>{client.GSTName}</td>
                                    <td>{client.GSTNumber}</td>
                                    <td>
                                        <div className="action-buttons">
                                            <button
                                                className="accept-btn"
                                                title="Accept"
                                                onClick={() => handleAccept(client.id)}
                                            >
                                                <FaCheck />
                                            </button>

                                            <button
                                                className="reject-btn"
                                                title="Reject"
                                                onClick={() => handleReject(client.id)}
                                            >
                                                <FaTimes />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}>
                                    No clients found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


            </div>
        </div>
    );
};

export default Clients;
